import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem, ToolTip } from 'design-system';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import useDefaultScoreBands from '../hooks/useDefaultScoreBands';
import { isWeb } from '../../../constants';
const strings = {
    title: 'TransUnion score bands',
    subtitle: 'TransUnion score bands are detailed below. Each band equates to a different number of points',
};
const ModalContent = memo(() => {
    const scoreBands = useDefaultScoreBands();
    return (<View style={styles.container}>
      <Text TextThin-14 Secondary centered>
        {strings.subtitle}
      </Text>

      <View style={styles.list}>
        {scoreBands.map((band, index) => (<View key={index} style={styles.row}>
            <View style={styles.labelGroup}>
              <Squircle color={band.midColor} width={rem(24)} height={rem(24)}/>
              <Text Text-16 centered>
                {band.label}
              </Text>
            </View>
            <Text Numbers-16 centered>
              {`${band.min}-${band.max}`}
            </Text>
          </View>))}
      </View>
    </View>);
});
const CreditScoreBandsTooltip = memo(({ offset = 0 }) => (<ToolTip title={strings.title} subtitle={<ModalContent />} small offset={isWeb ? 0 : offset}/>));
const styles = StyleSheet.create({
    container: {
        gap: rem(24),
    },
    list: {
        gap: rem(32),
        marginVertical: rem(8),
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    labelGroup: {
        flexDirection: 'row',
        gap: rem(16),
    },
});
export default CreditScoreBandsTooltip;
